import * as React from 'react';
import { hot } from 'react-hot-loader';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import { BrowserRouter } from 'react-router-dom';
import { AppWindow } from './window';
import { SkeletonLayout } from './Layout';
let Layout = undefined as any;
try {
    Layout = require('../../../../src/Layout').default as any as React.ComponentClass;
} catch (e) {
    // Dump
}

export class SkeletonApp extends React.Component {
    render() {
        return <BrowserRouter key="router" basename={(window as any as AppWindow).appConfig.moduleContextPath ? (window as any as AppWindow).appConfig.moduleContextPath : (window as any as AppWindow).appConfig.serverContextPath}>
            {Layout ? React.createElement(Layout) : <SkeletonLayout />}
        </BrowserRouter>;
        //false && __DEV__ && !client.isMobile() && <Explosions />, // TODO client.js nechceme zatím nebudou exploze
    }
}
export interface ConnectedAppProps {
    store: Store<any>;
}
export class App extends React.Component<ConnectedAppProps, {}> {
    render() {
        const {store} = this.props;
        return (
            <Provider store={store} key="provider">
                <SkeletonApp />
            </Provider>
        );
    }
}

export const hotApp = hot(module)(App);
